import { ArrowRightOnRectangleIcon, BuildingOffice2Icon, UserCircleIcon } from '@heroicons/react/24/outline';
import { meinKontoUrl } from '../util/meinKonto';
import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import MandantenTab from '../components/admin/MandantenTab';

/**
 * Betreiber-Konsole (admin.powercare.cloud) — Christian 08.09.: „demo und admin gehören auf keinen Fall
 * zusammen … das muss strikt getrennt werden." Diese Seite laeuft OHNE Mandantenkontext: kein
 * Praxis-Arbeitsplatz, keine Akten, keine Chats — nur Mandanten anlegen und einrichten. Anmeldung
 * ueber PowerID, Gruppe powercare-admin (Betreiber), nicht ueber Praxis-Konten.
 */
export default function BetreiberKonsole() {
  const { user, logout } = useAuth();
  const [toast, setToast] = useState<{ msg: string; variant: 'ok' | 'err' } | null>(null);
  const flash = (msg: string, variant: 'ok' | 'err' = 'ok') => { setToast({ msg, variant }); setTimeout(() => setToast(null), 3200); };
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="flex h-14 items-center justify-between bg-ps-dark-900 px-5 text-white">
        <div className="flex items-center gap-2">
          <BuildingOffice2Icon className="h-5 w-5 text-primary-300" />
          <span className="font-semibold">PowerCare</span>
          <span className="text-sm text-ps-dark-300">Betreiber-Konsole</span>
        </div>
        <div className="flex items-center gap-3 text-sm">
          <span className="text-ps-dark-200">{user?.name || user?.username}</span>
          <a href={meinKontoUrl()} className="flex items-center gap-1 rounded-md bg-ps-dark-800 px-2.5 py-1.5 text-xs hover:bg-ps-dark-700"><UserCircleIcon className="h-4 w-4" /> Mein Konto</a>
          <button onClick={() => void logout()} className="flex items-center gap-1 rounded-md bg-ps-dark-800 px-2.5 py-1.5 text-xs hover:bg-ps-dark-700"><ArrowRightOnRectangleIcon className="h-4 w-4" /> Abmelden</button>
        </div>
      </header>
      <main className="mx-auto max-w-[1920px] px-4 py-6 sm:px-6 lg:px-8">
        <div className="mb-4 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800">
          Betreiber-Sicht: Hier werden Mandanten (Praxen) angelegt und eingerichtet. Patientendaten der Mandanten sind hier nicht erreichbar — dafür meldet man sich auf der Adresse der jeweiligen Praxis an.
        </div>
        <MandantenTab flash={flash} />
      </main>
      {toast && <div className={`fixed bottom-6 right-6 z-40 rounded-md border px-4 py-3 text-[13px] shadow-md ${toast.variant === 'ok' ? 'border-emerald-200 bg-emerald-50 text-emerald-800' : 'border-rose-200 bg-rose-50 text-rose-700'}`}>{toast.msg}</div>}
    </div>
  );
}
